import { OpalApiComponent } from '@opallabs/api'
import { linkageFromResource } from '@opallabs/json-api'
import { deepMerge } from '@opallabs/lambda'
import { ObjectFactory } from '../types'

type WorkflowV2 = OpalApiComponent<'V2', 'workflow'>

const V2: ObjectFactory<WorkflowV2> = (overrides) => {
  const defaults: WorkflowV2 = {
    id: '2ebc62ca-87c3-4c4d-b1cf-7d6bc78d0bfa',
    type: 'workflow',
    attributes: {
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      deleted_at: null,
      status: 'inactive',
      is_approved: false,
      progress: 'not_started',
      ...overrides?.attributes,
    },
    meta: {
      latest_active_stage: {
        assignment_counts: {
          all: {
            complete: 0,
            incomplete: 1,
          },
          current_user: {
            complete: 0,
            incomplete: 0,
          },
          declined: 0,
        },
        stage_type: 'circuit_breaker',
        resource_identifier: {
          data: {
            id: '2ebc62ca-87c3-4c4d-b1cf-7d6bc78d0bfa',
            type: 'stage',
          },
        },
      },
      stage_type_count: {
        approval: 0,
        task: 1,
        circuit_breaker: 1,
      },
      completed_stages: 0,
    },
    relationships: {
      stages: {
        data: [
          {
            id: '2ebc62ca-87c3-4c4d-b1cf-7d6bc78d0bfa',
            type: 'stage',
          },
          {
            id: '2ebc62ca-87c3-4c4d-b1cf-7d6bcd4681d2',
            type: 'stage',
          },
        ],
      },
      created_by_user: linkageFromResource({
        id: 'cd4681d2-4ca9-407d-84ce-7d6bc78d0bfa',
        type: 'user',
      }),
    },
  }
  return deepMerge(overrides, defaults)
}

export const Workflows = {
  V2,
}
